import React from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { matchPath } from "react-router-dom";

import { Breadcrumb } from "./Breadcrumb";
import { pagesConfig, MenuItem, MenuItemEnfant } from "@/router/pagesConfig";
import { useConfig } from "@/contexts/config";

export const FilAriane = () => {
  const { t } = useTranslation();
  //const param = useParams();
  const location = useLocation();
  const { config } = useConfig();

  const findChildByUrl = (items: MenuItem[]): MenuItemEnfant | null => {
    for (const item of items) {
      if ("subItems" in item) {
        const found = findChildByUrl(item.subItems);
        if (found) {
          return found;
        }
      } else if (matchPath({ path: item.link, end: true }, location.pathname)) {
        return item;
      }
    }
    return null;
  };

  const itemCorrespondant = findChildByUrl(pagesConfig(t, config));

  return (
    <Breadcrumb
      title={itemCorrespondant?.titre || ""}
      description={itemCorrespondant?.pageDescription || ""}
    />
  );
};
